export const sdkTagsKeys = {
  all: ['sdk-tags'] as const,
  list: (accountId: string) =>
    [...sdkTagsKeys.all, 'list', { accountId }] as const,
  blockedEvents: (accountId: string) =>
    [...sdkTagsKeys.all, 'blocked-events', { accountId }] as const,
  conversionEvents: (accountId: string) =>
    [...sdkTagsKeys.all, 'conversion-events', { accountId }] as const,
}
